 <!-- 我的订单 -->
<template>
  <div class="enroll">
    <div class="head">
      <div class="head-left"> 
        <p class="title">我的订单</p>
      </div>
    </div>
    <div class="nav-list" v-if="cur==1">
      <ul>
        <li class="type" :class="type==2?'cur':''" @click="onCur(2)">考试订单</li>
        <li class="bar divider">|</li>
        <li class="type" :class="type==1?'cur':''" @click="onCur(1)">课程订单</li>
      </ul>
    </div>
    <div class="order-type">
      <el-radio-group v-model="tabPosition" style="margin-bottom: 30px;" @input="onButton">
        <el-radio-button label="-1">全部</el-radio-button>
        <el-radio-button label="0">待付款</el-radio-button>
        <el-radio-button label="1">已支付</el-radio-button>
        <el-radio-button label="2">已取消</el-radio-button>
        <el-radio-button label="3">已退款</el-radio-button>
      </el-radio-group>
    </div>
    <div class="order-item">
      <div class="order-item-top">
        <p class="order-item-top-left">订单信息</p>
        <div class="order-item-top-right">
          <p>订单金额</p>
          <p>订单状态</p>
          <p>订单操作</p>
        </div>
      </div>
      <ul class="order-item-ul">
        <li class="order-item-ul-li" v-for="item,index in orderList" :key="index">
          <p class="order-item-ul-li-number">订单编号：{{item.orderNum}}</p>
          <div class="order-item-ul-li-content">
            <div class="order-item-ul-li-content-img">
              <img :src="item.goodImg">
              <div>
                <p>{{item.goodName}}</p>
                <!-- <p class="enroll-list-intotal-period" v-if="type==1">录播课</p> -->
              </div>
            </div>
            <div class="order-item-ul-li-content-information">
              <div style="margin-top: 5px;width: 33%;">
                <p class="order-item-ul-li-content-information-moeny">￥{{item.payAmount}}</p>
                <p class="order-item-ul-li-content-information-time">{{item.payType==0?'':(item.payType==6 || item.payType==7?'支付宝':'微信')}}<br>{{item.payTime}}</p>
              </div>
              <div style="width: 33%">
                <p class="order-item-ul-li-content-information-type" v-if="item.status==0">待付款</p>
                <p class="order-item-ul-li-content-information-type" v-else-if="item.status==1">已支付</p>
                <p class="order-item-ul-li-content-information-type" v-else-if="item.status==2">已取消</p>
                <p class="order-item-ul-li-content-information-type" v-else-if="item.status==3">已退款</p>
              </div>
              
              <div style="width: 33%; text-align: center;">
                <!-- <el-popconfirm
                  title="确定取消当前订单吗？"
                  @confirm="signCancel(item.id)"
                  v-if="item.status==0"
                >
                  <el-button slot="reference" class="buttonl" size="small" round style="border: 1px solid #f25e0a;color: #f25e0a;">取消订单</el-button>
                </el-popconfirm> -->
                <el-popconfirm
                  title="确定申请退款吗？"
                  @confirm="signCancel(item.id)"
                  v-if="type == 2 && item.status==1"
                >
                  <el-button slot="reference" class="buttonl" size="small" round style="border: 1px solid #f25e0a;color: #f25e0a;">申请退款</el-button>
                </el-popconfirm>
                <!-- <el-popconfirm
                  title="确定删除当前订单吗？"
                  @confirm="signCancel(item.id)"
                  v-else-if="item.status==3"
                >
                  <el-button slot="reference" class="buttonl" size="small" round style="border: 1px solid #f25e0a;color: #f25e0a;width: 80px;">删除</el-button>
                </el-popconfirm> -->
                <el-button  class="buttons" size="small" type="warning" round style="background-color: #ff821c" v-if="item.status==0" @click="submitCoupon(item.id,item.payType,item.type)">立即支付</el-button>
                <p style="width: 80px;" v-if="item.status==2"></p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :current-page="page"
        :page-size="rows"
        @current-change="currentChange">
      </el-pagination>
    </div>

    <div class="popup">
      <el-dialog title="" :visible.sync="dialogFormVisible">
        <p class="popup-title">微信支付</p>
        <div class="popup-form" style="padding:60px 180px 80px;text-align: center">
          <img class="popup-share-img" :src="examHtml">
          <p class="popup-share-text">微信扫描二维码支付</p>
          <el-button style="background-color: #ff821c" size="medium" type="warning" @click="getOrderInfo">我已支付</el-button>
        </div>
      </el-dialog>
    </div>
    
  </div>
</template>

<script>
import { myOrder,examPay,refundOrder,coursePay,orderInfo } from '../../api/userMG'
export default {
  data() {
    return {
      cur:1,
      type:2,
      tabPosition: '-1',
      orderList:[],
      page:1,
      rows:10,
      total:0,
      dialogFormVisible:false,
      examHtml:'',
      orderId:''
    }
  },
  computed: {
    url() {
      return this.$store.getters.url;
    }
  },
  created() {
    this.getMyOrder();
  },
  methods:{
    // 获取订单列表
    async getMyOrder(){
      let params = {
        page:this.page,
        rows:this.rows,
        type:this.type,
        status:this.tabPosition=='-1'?'':Number(this.tabPosition)
      }
      await myOrder(params).then(res => {
        console.log('订单列表',res);
        this.orderList = res.data.content;
        this.total = res.data.total;
      })
    },
    onCur(e){
      this.type = e;
      this.getMyOrder();
    },
    onButton(e){
      console.log(e)
      this.getMyOrder();
    },
    onExamPage(){
      this.$router.push({path:'/exam/examPage'})
    },
    currentChange(e){
      this.page = e;
      this.getMyOrder()
    },
    // 跳转支付
    submitCoupon(id,payType,type){
      this.orderId = id;
      console.log("payType",payType)
      if(payType==6 || payType==7){
        // 'de9e80378ebf4f6fbad0fedde1140626'
        if(type==2){
          this.$router.push({path:'/pay/Order', query: { payType: 6,orderId:id}})
        }else{
          this.$router.push({path:'/pay/Orderz', query: { payType: 6,orderId:id}})
        }
      }else{
        let params = {
          payType:3,
          orderId:id
        }
        let pay
        if(type==2){
          pay = examPay
        }else{
          pay = coursePay
        }
        pay(params).then(res => {
          console.log('支付',res);
          if(res.code==0){
            this.examHtml = res.data;
            this.dialogFormVisible = true;
          }
        })
        .catch(err => {
        })
      }
    },
    getOrderInfo(){
      orderInfo({id:this.orderId}).then(res => {
        console.log('支付详情',res);
        let orderStatus = res.data.status;
        if(orderStatus==0){
          this.$message({
            message: '您还未支付',
            type: 'warning',
            offset:100
          })
        }else{
          location.reload()
        }
      })
    },

    // 取消订单
    signCancel(id){
      let params = {
        orderId:id
      }
      refundOrder(params).then(res => {
        if(res.code == 0){
          this.$message({
            type: 'info',
            message: '已申请',
            offset:100
          });
          this.getMyOrder();
        }
      }).catch(err => {})
    },


  }
}
</script>

<style scoped>
  .enroll{
    padding: 30px 20px 50px;
    background-image: linear-gradient(bottom,#fff,#fff8f2);
    border: 1px solid #e1e2e6;
    border-radius: 8px;
  }
  .head{
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #e6e6e6;
  }
  .head .title{
    font-size: 14px;
    font-weight: 500;
    color: black;
    letter-spacing: 1px;
    margin-bottom: 15px;
  }
  .nav-list{
    margin-top: 20px;
  }
  .nav-list ul{
    display: flex;
    align-items: center;
  }
  .nav-list ul li{
    font-size: 13px;
    padding: 10px 0;
    cursor: pointer;
  }
  .divider{
    margin:  0 40px;
  }
  .nav-list ul .bar{
    color: #e1e2e6;
  }
  .nav-list ul .type{
    color: black;
  }
  .cur{
    color: #ff821c !important;
    border-bottom: 2px solid #ff821c;
  }
  .order-type{
    margin-top: 30px;
  }

  .el-radio-group{
    width: 100%;
  }
  .el-radio-button{
    width: 20%;
  }
  .order-type /deep/ .el-radio-button__inner{
    width: 100%;
    padding: 12px 0;
    color: black;
    font-size: 13px;
    background-color: #fafafa;
  }
  .order-type /deep/ .el-radio-button__inner:hover{
    color: black;
  }
  .order-type /deep/ .is-active .el-radio-button__inner{
    background-color: #ff821e;
    border-color: #ff821e;
    box-shadow: -1px 0 0 0 #ff821e;
    color: #fff;
  }

  .order-item{
    margin-bottom: 40px;
  }
  .order-item-top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f1f1f1;
    padding: 0 18px 8px;
    margin-bottom:15px;
  }
  .order-item-top-left{
    width: 40%;
  }
  .order-item-top-left, .order-item-top-right p{
    font-size: 12px;
    color: #6c6c6c;
  }
  .order-item-top-right p{
    width: 33%;
    text-align: center;
  }
  .order-item-top-right{
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .order-item-ul-li{
    border: 1px solid #eeeeee;
    margin-bottom: 18px;
  }
  .order-item-ul-li-number{
    padding: 10px 17px;
    background-color: #fafafa;
    font-size: 12px;
    color: #9d9d9d;
  }
  .order-item-ul-li-content{
    padding: 16px 17px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .order-item-ul-li-content-img{
    width: 40%;
    display: flex;
    align-items: center;
  }
  .order-item-ul-li-content-img img{
    width: 170px;
    /* height: 100px; */
    border-radius: 4px;
    margin-right: 14px;
  }
  .order-item-ul-li-content-img p{
    font-size: 13px;
    color: #757575;
    line-height: 15px;
  }
  .enroll-list-intotal-period{
    width: 50px !important;
    height: 18px;
    font-size: 11px !important;
    border-radius: 2px;
    background: #fcf2e8;
    color: #f25902 !important;
    margin-top: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 11px;
  }
  .order-item-ul-li-content-information{
    display: flex;
    justify-content: space-between;
    width: 50%;
  }
  .order-item-ul-li-content-information-moeny{
    font-size: 16px;
    color: #f15f09;
    font-weight: 600;
    text-align: center;
  }
  .order-item-ul-li-content-information-time{
    font-size: 12px;
    color: #9f9f9f;
    line-height: 14px;
    margin-top: 6px;
    text-align: center;
  }
  .order-item-ul-li-content-information-type{
    font-size: 13px;
    color: black;
    margin-top: 5px;
    width: 100%;
    text-align: center;
  }
  .pagination /deep/ .active{
    background: #ff821c !important;
  }
  /* .pagination /deep/ .number:hover{
    color: #ff821c !important;
  } */
  /* .pagination /deep/ .el-icon-d-arrow-left , .pagination /deep/ .el-icon-d-arrow-right{
    color: #ff821c !important;
  } */
  .buttonl:hover{
    background: none;
  }
  .popup /deep/ .el-dialog__header, .popup /deep/ .el-dialog__body{
    padding: 0;
  }
  .popup /deep/ .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
    font-size: 19px;
  }
  .popup /deep/ .el-dialog{
    border-radius: 8px;
  }
  .popup-title{
    background: #ff821e;
    color: #fff;
    font-size: 16px;
    padding: 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .popup-form{
    padding: 40px 110px;
  }
  .popup-share-img{
    width: 200px;
    height: 200px;
  }
  .popup-share-text{
    font-size: 15px;
    color: black;
    text-align: center;
    border-bottom: 2px dotted  #ebebeb;
    padding-bottom: 20px;
    margin-bottom: 30px;
  }
</style>


// WEBPACK FOOTER //
// src/views/order/order.vue